module.exports = __webpack_public_path__ + "static/media/VMIPO_ForgetPassword.31a9246a.jpg";